import React from 'react';
import IotBattery from './IotBattery.tsx';
import TriggerAlerts from './TriggerAlertUpdated.tsx';
import DescriptionBox from "../../../components/DescriptionBox/index.tsx";

const PushButton = () => {
  return (
    <div className="flex flex-col gap-8">
      <IotBattery
        header={
          <DescriptionBox
            title="Push Button"
            subTitle="Battery Health"
            description="Real-time battery status and health monitoring for push button devices."
          />
        }
      />
      <TriggerAlerts />
    </div>
  )
}

export default PushButton;
